export const daysOrder: string[] = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday",
];

export enum AddressFilter {
    LimitedAccess = 'LIMITED_ACCESS',
    Residential = 'RESIDENTIAL',
    FullyVerified = 'FULLY_VERIFIED',
    GateCodeRequired = 'GATE_CODE_REQUIRED',
}

export const shortDays: string[] = ["M", "T", "W", "Th", "F"];